import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import World from "@fae/source/models/World.js"
import Stage from "@fae/source/models/Stage.js"
import Step from "@fae/source/models/Step.js"
import Random from "@fae/source/utility/Random.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"

import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"

import * as DiceboundFlow from "@fae/source/data/games/ember/scripts/DiceboundFlow.js"
import GenerateEncounter from "@fae/source/data/games/ember/scripts/GenerateEncounter.js"
import GenerateOverworldMap from "@fae/source/data/games/ember/scripts/GenerateOverworldMap.js"
import EmberRandomEvents from "@fae/source/data/games/ember/scripts/EmberRandomEvents.js"
import HandleStatusEffects from "@fae/source/data/games/ember/scripts/HandleStatusEffects.js"
import HandleArmor from "@fae/source/data/games/ember/scripts/HandleArmor.js"
import HandleSlowDeath from "@fae/source/data/games/ember/scripts/HandleSlowDeath.js"
import RollPhase from "@fae/source/data/games/ember/scripts/RollPhase.js"
import InterstitialModal from "@fae/source/data/games/ember/scripts/modals/InterstitialModal.jsx"
import OverworldModal from "@fae/source/data/games/ember/scripts/modals/OverworldModal.jsx"
import LootPassiveModal from "@fae/source/data/games/ember/scripts/modals/LootPassiveModal.jsx"
import LootModal from "@fae/source/data/games/ember/scripts/modals/LootModal.jsx"

import RollingHud from "@fae/source/data/games/ember/views/hud/RollingHud.jsx"

const STARTING_ROLLCOUNT = 5

export default {
    "key": "X-1",
    "stage": {
        "configuration": {
            // "isRenderingEncounters": true,
            // "isRenderingSpots": true,
            "useEquippedItemOnly": true,
            "isNotDividedByTen": true,
        },
        "images": [
            // {
            //     "url": require("../bg.png"),
            //     "position": {"x": 1.5, "y": 5, "z": 1},
            //     "width": 16, "height": 9,
            //     // "screenspace": "camera",
            // },
            // {
            //     "url": require("./map_26x21.png"),
            //     "position": {"x": 0, "y": 0, "z": 2},
            //     "width": 26, "height": 21,
            //     "isSquiggling": true,
            // }
        ],
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
            "width": 16 * 13,
            "height": 32,
        }),
        "hud": RollingHud,
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    PlotSteps.ReportStartingAnalytics(),
                    // PlotSteps.PlayStinger("Stinger:Start"),
                    // PlotSteps.ChapterStart(["Level 0", "Dungeon of the Slime Queen"]),

                    GenerateOverworldMap(),
                    OverworldModal(),

                    PlotSteps.PlayAudio("Ambience"),
                    PlotSteps.PlayAudio("Ember:Music:Encounter:1"),

                    GenerateEncounter(1),
                    PlotSteps.SpawnPlayerParty({
                        "defaultPartyUnitKeys": ["ashe", "gwyn", "mara"]
                    }),

                    Step.deltastage({
                        "player": {
                            "zoomout": 0.8,
                        },
                    }),

                    Step.deltastage({
                        "player": {
                            "rollcount": STARTING_ROLLCOUNT
                        },
                    }),

                    RollPhase(),
                ]
            },
            {
                "trigger": "turn:every-odd:start",
                "events": [
                    PlotSteps.PlayStinger("Stinger:EnemyTurn"),
                    PlotSteps.TurnStart("bad"),
                ]
            },
            {
                "trigger": "turn:every-odd:end",
                "events": [
                    HandleSlowDeath(),
                    RollPhase(),
                    HandleStatusEffects(),
                    HandleArmor(),
                ]
            },
            {
                "isWinCondition": true,
                "condition": (stage) => {
                    return PlotConditions.areAllAffiliatedUnitsDead(stage, {"affiliation": "bad"})
                },
                "events": [
                    HandleSlowDeath(), // WHY IS THIS TURNING OFF LOOTING??
                    // LootModal(),
                    // ...LootModal(), // TODO: WHY MUST THIS BE DECONSTRUCTED??
                    (stage) => {
                        const encounterType = stage?.overworld?.player?.encounter?.type ?? "first-combat"
                        if(encounterType == "standard-combat"
                        || encounterType == "first-combat"
                        || encounterType == "elite-combat") {
                            return LootModal()
                        }
                    },
                    (stage) => {
                        if(stage.overworld?.player?.encounter == undefined) return
                        if(stage.overworld.player.encounter.type == "elite-combat") {
                            return LootPassiveModal()
                        }
                    },
                    PlotSteps.PlayAudio("Ember:Music:Titlescreen"),

                    // InterstitialModal(), // campfire only!!! not after EVERY encounter.
                    OverworldModal(),

                    // deduped in WhatHappensNext()
                    (stage) => {
                        const nextEncounterKey = parseInt(stage.currentEncounterKey) + 1

                        if(stage.overworld?.player?.encounter == undefined) return
                        // console.log(stage.overworld.player.encounter)
                        // if(stage.overworld.player.encounter.type == "merchant") {
                        //     // return {"func": () => console.log("1!!")}
                        //     return ["BUY SOMETHING WILL YA"]
                        // }
                        if(stage.overworld.player.encounter.type == "random") {
                            const randomEvent = stage.random.element(EmberRandomEvents)
                            return [
                                PlotSteps.PlayAudio("Dicebound:Music:2"),
                                GenerateEncounter(nextEncounterKey),
                                DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
                                PlotSteps.Wait(1000, {"isUnskippable": true}),
                                "SOMETHING RANDOM HAPPENS",
                                randomEvent,
                            ]
                        }
                        if(stage.overworld.player.encounter.type == "campfire") {
                            return [
                                PlotSteps.PlayAudio("Ember:Music:Campfire"),
                                GenerateEncounter(nextEncounterKey),
                                DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
                                PlotSteps.Wait(1000, {"isUnskippable": true}),
                                "GET SOME REST",
                                PlotSteps.HealPlayerParty({"percent": 1}),
                            ]
                        }
                        if(stage.overworld.player.encounter.type == "treasure") {
                            // return {"func": () => console.log("4!!")}
                            return [
                                PlotSteps.PlayAudio("Dicebound:Music:2"),
                                GenerateEncounter(nextEncounterKey),
                                DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
                                "GET A TREASURE!!",
                                LootPassiveModal(),
                            ]
                        }
                        if(stage.overworld.player.encounter.type == "exit") {
                            return [
                                PlotSteps.ReportSuccessAnalytics(),
                                PlotSteps.PlayAudio("Stinger:Success"),
                                PlotSteps.ChapterSuccess(),
                                PlotSteps.TransitionStart({"isUnskippable": true}),
                                PlotSteps.Wait(250, {"isUnskippable": true}),
                                PlotSteps.WaitingModal({"isUnskippable": true, "duration": 2000}),
                                PlotSteps.KillAudio({"label": "ambience"}),
                                {"func": () => Navigation.go("/games/ember")}
                            ]
                        }

                        const ENCOUNTER_MUSIC = {
                            "standard-combat": "Ember:Music:Encounter:1",
                            "elite-combat": "Ember:Music:Encounter:2",
                            "boss-combat": "Dicebound:Music:Boss",
                        }
                        // stage.overworld.player.encounter.type == "standard-combat"
                        // stage.overworld.player.encounter.type == "elite-combat"
                        return [
                            PlotSteps.PlayAudio(ENCOUNTER_MUSIC[stage.overworld.player.encounter.type] ?? ENCOUNTER_MUSIC["standard-combat"]),
                            // PlotSteps.HealPlayerParty({"percent": 1}),
                            // PlotSteps.HealPlayerParty({"percent": 0.5, "isDead": true}),
                            GenerateEncounter(nextEncounterKey),
                            DiceboundFlow.MoveToNewEncounter({"nextEncounterKey": nextEncounterKey, "spotTag": "goodspawn"}),
                            Step.deltastage({
                                "player": {
                                    "rollcount": STARTING_ROLLCOUNT
                                },
                            }),
                            RollPhase(),
                        ]
                    },
                ]
            },
            {

                "condition": function(stage) {
                    return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                },
                "events": [
                    PlotSteps.PlayAudio("Stinger:Failure"),
                    PlotSteps.KillAudio({"label": "ambience"}),
                    PlotSteps.ReportFailureAnalytics(),
                    PlotSteps.ChapterFailure(),
                    {"func": () => App.game.chapter.restart()},
                ]
            },
        ]
    },
}
